import { useEffect, useRef, useState } from 'react';

export function useBusinessAction() {
  const alive = useRef(true), running = useRef(false);
  const [state, setState] = useState({ busy: false, error: null, message: null });
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const run = async (operation, message) => {
    if (running.current) return;
    running.current = true; setState({ busy: true, error: null, message: null });
    const isRequestCurrent = () => alive.current;
    try {
      const result = await operation({ isRequestCurrent });
      if (alive.current) setState({ busy: false, error: null, message });
      return result;
    } catch (error) { if (alive.current) setState({ busy: false, error: error.message || 'Please try again.', message: null }); }
    finally { running.current = false; }
  };
  return { ...state, run, current: () => alive.current };
}
